const translations = {
  inactivity: {
    info:
      "Sie werden in {{seconds}} Sekunden automatisch zur Startseite zurückgeleitet...",
    toContinue: "Bitte berühren Sie den Bildschirm, um mit Ihrem Vorgang fortzufahren.",
  },
};

export {translations};
